module.exports = __webpack_public_path__ + "static/media/circular-wall-clock.36184cb9.svg";